<template>
  <div>
    <b-tabs>

      <b-tab active :title="$t('providers')">
        <div v-if="!loading">
          <b-row class="align-items-center mt-2 mx-0">
            <b-col
              v-for="(item, index) in response1.results"
              :key="index"
              class="col-lg-3 col-12 col-md-6"
            >
              <b-card
                class="overflow-hidden cursor-pointer card__contact"
                no-body
                @click="$router.push(`/contacts/detail/${item.id}`)"
              >
                <b-row class="align-items-center">
                  <b-col class="col-lg-4 col-4 pr-0">
                    <b-img
                      v-if="item.photo"
                      :src="item.photo"
                      :alt="item.name"
                      class="rounded-0 item px-1 py-50"
                      style="min-width: 110px;"
                    />
                    <b-img
                      v-else
                      :src="
                        item.entity
                          ? require('@/views/modules/Contacts/assets/comp.svg')
                          : require('@/views/modules/Contacts/assets/human.svg')
                      "
                      alt="Image"
                      class="rounded-0 item h-100 img-fluid px-1 py-50"
                      style="min-width: 110px;"
                    />
                    <template v-if="item.parent">
                      <b-img
                        v-if="item.parent.photo"
                        :src="item.parent.photo"
                        :alt="item.parent.name"
                        class="rounded-0 sub-company item px-1 py-50"
                        style="min-width: 110px;"
                      />
                      <b-img
                        v-else
                        :src="
                          item.parent.entity
                            ? require('@/views/modules/Contacts/assets/comp.svg')
                            : require('@/views/modules/Contacts/assets/human.svg')
                        "
                        :alt="item.parent.name"
                        class="rounded-0 sub-company item px-1 py-50"
                        style="min-width: 110px;"
                      />
                    </template>
                  </b-col>

                  <b-col class="col-lg-8 col-8 pl-0">
                    <div class="px-1">
                      <h6 class="crop-name">
                        <feather-icon
                          class="mt-0"
                          icon="HomeIcon"
                        />
                        {{ item.company_name }}
                      </h6>

                      <div>
                        <small class="mt-50">
                          <feather-icon
                            class="mt-0"
                            icon="AlertCircleIcon"
                          />
                          {{ item.inn }}
                        </small>
                      </div>

                      <div>
                        <small class="mt-50">
                          <feather-icon
                            class="mt-0"
                            icon="PhoneIcon"
                          />
                          {{ item.phone_number }}
                        </small>
                      </div>

                      <div>
                        <small class="mt-50">
                          <feather-icon
                            class="mt-0"
                            icon="PhoneIcon"
                          />
                          {{ item.email }}
                        </small>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <Pagination
            class="w-100"
            :params="filter"
            :rows="response1.count"
            @refresh="changeContactTable"
            :page="filter.page"
            :page_size="filter.page_size"
            :page_options="[12, 24, 36, 48, 100]"
          />
        </div>

        <div v-else>
          <Loader />
        </div>
      </b-tab>


      <b-tab :title="$t('buyers')">
        <div v-if="!loading">
          <b-row class="align-items-center mt-2 mx-0">
            <b-col
              v-for="(item, index) in response2.results"
              :key="index"
              class="col-lg-3 col-12 col-md-6"
            >
              <b-card
                class="overflow-hidden cursor-pointer card__contact"
                no-body
                @click="$router.push(`/contacts/detail/${item.id}`)"
              >
                <b-row class="align-items-center">
                  <b-col class="col-lg-4 col-4 pr-0">
                    <b-img
                      v-if="item.photo"
                      :src="item.photo"
                      :alt="item.name"
                      class="rounded-0 item px-1 py-50"
                      style="min-width: 110px;"
                    />
                    <b-img
                      v-else
                      :src="
                        item.entity
                          ? require('@/views/modules/Contacts/assets/comp.svg')
                          : require('@/views/modules/Contacts/assets/human.svg')
                      "
                      alt="Image"
                      class="rounded-0 item h-100 img-fluid px-1 py-50"
                      style="min-width: 110px;"
                    />
                    <template v-if="item.parent">
                      <b-img
                        v-if="item.parent.photo"
                        :src="item.parent.photo"
                        :alt="item.parent.name"
                        class="rounded-0 sub-company item px-1 py-50"
                        style="min-width: 110px;"
                      />
                      <b-img
                        v-else
                        :src="
                          item.parent.entity
                            ? require('@/views/modules/Contacts/assets/comp.svg')
                            : require('@/views/modules/Contacts/assets/human.svg')
                        "
                        :alt="item.parent.name"
                        class="rounded-0 sub-company item px-1 py-50"
                        style="min-width: 110px;"
                      />
                    </template>
                  </b-col>

                  <b-col class="col-lg-8 col-8 pl-0">
                    <div class="px-1">
                      <h6 class="crop-name">
                        <feather-icon
                          class="mt-0"
                          icon="HomeIcon"
                        />
                        {{ item.company_name }}
                      </h6>

                      <div>
                        <small class="mt-50">
                          <feather-icon
                            class="mt-0"
                            icon="AlertCircleIcon"
                          />
                          {{ item.inn }}
                        </small>
                      </div>

                      <div>
                        <small class="mt-50">
                          <feather-icon
                            class="mt-0"
                            icon="PhoneIcon"
                          />
                          {{ item.phone_number }}
                        </small>
                      </div>

                      <div>
                        <small class="mt-50">
                          <feather-icon
                            class="mt-0"
                            icon="PhoneIcon"
                          />
                          {{ item.email }}
                        </small>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <Pagination
            class="w-100"
            :params="filter2"
            :rows="response2.count"
            @refresh="changeBuyerContactTable"
            :page="filter2.page"
            :page_size="filter2.page_size"
          />
        </div>

        <div v-else>
          <Loader />
        </div>
      </b-tab>

    </b-tabs>
  
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BRow, BCol, BCard, BImg, BSpinner, BTabs, BTab, } from 'bootstrap-vue'
import Pagination from "@/components/Pagination.vue";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BImg,
    BSpinner,
    // VuePerfectScrollbar,
    BTabs,
    BTab,

    Pagination,
    Loader,
  },
  data() {
    return {
      loading: false,
      filter: {
        page: 1,
        page_size: 12,
      },
      filter2: {
        page: 1,
        page_size: 12,
      },
      response1: [],
      response2: [],
    }
  },
  computed: {
    ...mapGetters('contacts', ['GET_CONTACTS_TABLE_LIST']),

  },
  async mounted() {
    this.loading = true

    let page = this.$route.query.page
    let page_size = this.$route.query.page_size

    this.response1 = await this.FETCH_ALL_CONTACTS_LIST({ page: page ? page : 1, page_size: page_size ? page_size : 12, type: "provider"});
    this.response2 = await this.FETCH_ALL_CONTACTS_LIST({ page: page ? page : 1, page_size: page_size ? page_size: 12, type: "buyer" }); 

    if(page){
      this.filter.page = page
      this.filter2.page = page
    }
    if(page_size){
      this.filter.page_size = page_size
      this.filter2.page_size = page_size
    }

    this.loading = false
  },

  methods: {
    ...mapActions('contacts', ['FETCH_ALL_CONTACTS_LIST']),
  

    async changeContactTable() {
      this.loading = true;

      this.response1 = await this.FETCH_ALL_CONTACTS_LIST({...this.filter, type: "provider"});
      this.$router.replace({ path: "/contacts", query: { page: this.filter.page, page_size: this.filter.page_size } });

      this.loading = false;
    },



    async changeBuyerContactTable() {
      this.loading = true;

      this.response2 = await this.FETCH_ALL_CONTACTS_LIST({...this.filter2, type: "buyer"});
      this.$router.replace({ path: "/contacts", query: { page: this.filter2.page, page_size: this.filter2.page_size } });

      this.loading = false;
    },



  },

}
</script>
<style>
.card__contact:hover {
  transform: translateY(-3px);
}

.item {
  height: 150px !important;
  width: 100%;
  object-fit: contain;
}

.item {
  background-color: #fff;
}

.contact-scroll {
  max-height: 80vh;
}

.contact-scroll::-webkit-scrollbar {
  display: none;
}

.crop-name {
  font-size: 13px;
  overflow: hidden;
}

.crop-name-sub-company {
  font-size: 10px;
}
</style>
